import { spCandidateExamAttributesLocs } from './components/candidate-exam-outlet/candidate-exam-attributes/candidate-exam-attributes.locs';
import { spCandExamCardLocs } from './components/candidate-exam-outlet/candidate-exam-card/candidate-exam-card.locs';
import { spCandidateExamCommentsLocs } from './components/candidate-exam-outlet/candidate-exam-comments/candidate-exam-comments.locs';
import { spCandidateExamDetailLocs } from './components/candidate-exam-outlet/candidate-exam-details/candidate-exam-details.locs';
import { spInvalidateCandidateExamLocs } from './components/candidate-exam-outlet/candidate-exam-details/modals/invalidate-candidate-exam-modal/invalidate-candidate-exam-modal.locs';
import { spReviewCandidateExamLocs } from './components/candidate-exam-outlet/candidate-exam-details/modals/review-candidate-exam-modal/reveiw-candidate-exam-modal.locs';
import { spCandidateExamItemsLocs } from './components/candidate-exam-outlet/candidate-exam-items/candidate-exam-items.locs';
import { spCandidateExamSectionLocs } from './components/candidate-exam-outlet/candidate-exam-sections/candidate-exam-sections.locs';
import { spCandidateExamSurveyItemsLocs } from './components/candidate-exam-outlet/candidate-exam-survey-items/candidate-exam-survey-items.locs';
import { spCandidateHistoryExamViolationsLocs } from './components/candidate-exam-outlet/candidate-exam-violations/candidate-exam-violations.locs';
import { spCandidateHistoryExamViolationsModalLocs } from './components/candidate-exam-outlet/candidate-exam-violations/modals/create-exam-violation-modal/create-exam-violation-modal.locs';
import { spCandidateExamsLocs } from './components/candidate-exams/candidate-exams.locs';

export const spCandExamModuleLocs = {
	...spCandExamCardLocs,
	...spCandidateExamAttributesLocs,
	...spCandidateExamCommentsLocs,
	...spCandidateExamItemsLocs,
	...spCandidateExamSectionLocs,
	...spCandidateExamSurveyItemsLocs,
	...spInvalidateCandidateExamLocs,
	...spReviewCandidateExamLocs,
	...spCandidateHistoryExamViolationsModalLocs,
	...spCandidateHistoryExamViolationsLocs,
	...spCandidateExamsLocs,
	...spCandidateExamDetailLocs,
};
